export const iconFontUrl = "//at.alicdn.com/t/c/font_4167988_8nf40l026h.js";
